module.exports = __webpack_public_path__ + "static/media/unlock-credit-calendar.b664ccd4.svg";